import template from './solutionLightbox.html';
import './solutionLightbox.less';
import controller from './solutionLightbox.controller';

const SolutionLightboxComponent = {
  bindings: {
    resolve: '<',
    close: '&',
    dismiss: '&'
  },
  template,
  controller
};

export default SolutionLightboxComponent;




// WEBPACK FOOTER //
// ./src/components/search-form/solution-lightbox/solutionLightbox.component.js